import React, { FC, PropsWithChildren } from 'react'
import { createGlobalStyle, ThemeProvider as SCThemeProvider } from 'styled-components'
import theme from './theme'
import antdStyleOverwrites from './styles/antd'
import amplifydStyleOverwrites from './styles/amplify'
import { AVENIR_FONT } from './consts'

const GlobalStyles = createGlobalStyle`
	html, body, #__next {
		min-height: 100%;
		width: 100%;
		min-width: 100%;
		margin: 0;
		padding: 0;
		font-family: ${AVENIR_FONT};
	}

	#__next {
		min-height: 200px;
	}

	.cky-btn-revisit-wrapper, .cky-consent-container.cky-hide {
		display: none !important;
	}

	.cky-consent-container {
		display: none;
	}

	${amplifydStyleOverwrites}

	${antdStyleOverwrites}
`

const ThemeProvider: FC<PropsWithChildren> = ({ children }) => (
	<SCThemeProvider theme={theme}>
		<GlobalStyles />
		{children}
	</SCThemeProvider>
)

export default ThemeProvider
